import { STUDY_PLAN_TYPES } from "../../../app/contexts/constants/study.context.constants";

const { SCENARIO_A, SCENARIO_B } = STUDY_PLAN_TYPES;

// Strategy Pattern: Define validation strategies for each scenario
const scenarioStrategies = {
  [SCENARIO_A]: {
    validations: {
      validateSubjectsToScreen: (overallSubjectsToScreen, emptyCountrySubjectToScreen) => {
        const overallSubjectsToScreenVoid = overallSubjectsToScreen === 0 ||
          overallSubjectsToScreen === "" || isNaN(overallSubjectsToScreen);
        return overallSubjectsToScreenVoid && emptyCountrySubjectToScreen;
      },
    },
    messages: {
      getEmptySubjectsToScreenMessage: () => ({
        warning: `Please enter an Overall Enrollment Rate or specify enrollment rates for all countries.`,
        buttonType: "NEXT2",
      }),
      getWarningKey: () => "ENROLLMENT_RATE",
    },
  },
  [SCENARIO_B]: {
    validations: {
      validateSubjectsToScreen: () => {
        return false;
      },
    },
    messages: {
      getWarningKey: () => "ENROLLMENT_DURATION",
    },
  },
};

/**
 * Gets the appropriate strategy for the given study plan type
 * @param {string} studyPlanType - The type of study plan (SCENARIO_A or SCENARIO_B)
 * @returns {Object} Strategy object with validation methods
 */
export const getStrategy = (studyPlanType) => {
  const strategy = scenarioStrategies[studyPlanType];
  if (!strategy) {
    console.warn(`Unknown study plan type: ${studyPlanType}, using SCENARIO_A as default`);
    return scenarioStrategies[SCENARIO_A];
  }
  return strategy;
};